/// <reference path="config.d.ts" />

// Get user ID from gProxy-module
const userId = (window as any).gProxy ? (window as any).gProxy.getToken().UserId as string : "guest";
const instId = (window as any).gProxy ? (((window as any).gProxy.getToken().InstId as string) || "") : "";

// Prepare base URLs depending on current environment
const env = process.env.NODE_ENV;

let userData = '',
    gas = '',
    components = '',
    componentProxy = '',
    taskPlayer = '';

switch (env) {
    case 'production':
    case 'staging':
        userData = 'userdata-v2.gyldendal.dk';
        components = 'komponenter.gyldendal.dk';
        gas = 'gyldendalaccessservice.gyldendal.dk';
        componentProxy = 'componentframework.gyldendal.dk';
        taskPlayer = 'http://opgavegenerator.gyldendal.dk/layouts/layplayer.aspx';
        break;

    default:
        userData = 'test-userdata-v2.gyldendal.dk';
        components = 'test.komponenter.gyldendal.dk';
        gas = 'test-gyldendalaccessservice.gyldendal.dk';
        componentProxy = 'test-componentframework.gyldendal.dk';
        taskPlayer = 'http://stage2.sl-udv.dk/gyldendal/afvikler-v2.0/';
        break;
}

// Generate configurations
export default {
    userId: userId as string,

    API: {
        ekeyUser: `https://${gas}/api/User/GetEkeyUserDetailsByEmail?userEmail=%userId%`,
        unicUser: `https://${gas}/api/v1/UnicUser/GetPerson?userId=%userId%`,
        checkFavorite: `https://${userData}/api/Favorites?userID=${userId}&learningObjectID=%id%`,
        addFavorite: `https://${userData}/api/Favorites`,
        removeFavorite: `https://${userData}/api/Favorites?userID=${userId}&learningObjectID=%id%`,
        notebook: `http://${components}/notesbog/?userID=${userId}&institutionID=${instId}&productID=%id%`,
        componentEntry: `https://${userData}/api/ComponentEntries/%entryId%`,
        componentProxy: `https://${componentProxy}/Proxy/`,
        taskResult: `https://${userData}/api/TaskResults/%entryId%`,
        taskPlayer
    } as Config.API,
};



// WEBPACK FOOTER //
// ./js/config.ts